import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useDropzone } from "react-dropzone";
import { deleteTrackDb, deleteTrackStorage, UITrack, getMyTracks, MAX_UPLOADS, Plan, docToUiTrack } from "../firebase/firestore"
import { sum } from "../utils/arrays";
import useAuth from "./useAuth";
import { useStorageUpload } from "./useUpload";



export function useTracks(chunk = 5, initSelected = [], selectAfterUpload = false) {

    const { user } = useAuth()

    const [selectedTracks, setSelectedTracks] = useState<UITrack[]>(initSelected)
    const selectTrack = (uiTrack: UITrack) => setSelectedTracks(old => old.findIndex(olTrack => olTrack.track.id === uiTrack.track.id) !== -1 ? old : [...old, uiTrack])
    const deselectTrack = (uiTrack: UITrack) => setSelectedTracks(old => old.filter(olTrack => olTrack.track.id !== uiTrack.track.id))
    const trackSelected = (uiTrack: UITrack) => selectedTracks.findIndex(olTrack => olTrack.track.id === uiTrack.track.id) !== -1
    const { uploadFiles, fileUploads, cancelUpload, addUploadListener, updateFileUpload } = useStorageUpload()

    useEffect(() => {
        addUploadListener(t => selectAfterUpload ? selectTrack(t) : console.log(t));
        // return (() => addUploadListener(() => undefined))
    }, [addUploadListener])

    const fileUploadsArr = useMemo(() => Object.values(fileUploads).sort((f1, f2) => f2.track.uploadDate - f1.track.uploadDate), [fileUploads])

    const [existingTracks, setExistingTracks] = useState<UITrack[]>([])
    const [hasMore, setHasMore] = useState(true)
    const initLoad = useRef(false)
    const loadMoreExistingTracks = useCallback(async () => {

        if (!user) return
        let lastTrack = existingTracks[existingTracks.length - 1] || null
        // @ts-ignore
        let docs = await getMyTracks(user.uid, chunk + 1, lastTrack?.snapshot, fileUploadsArr.map(fUp => fUp.track.id))
        if (docs.length <= chunk) setHasMore(false)


        setExistingTracks(oldEx => oldEx.concat(docs.slice(0, chunk).map(docToUiTrack)))
    }, [existingTracks, user, fileUploadsArr])

    useEffect(() => {
        if (!initLoad.current && user) {
            initLoad.current = true
            loadMoreExistingTracks()
        }
    }, [user])

    const deleteTrack = useCallback(async (uiTrack: UITrack, relatedUpload = null) => {

        //@ts-ignore
        if (uiTrack.ref)
            try { await deleteTrackStorage(uiTrack.track, uiTrack.track.url) } catch (e) { console.log(e) }
        await deleteTrackDb(uiTrack.track.path)
        setExistingTracks(existingTracks.filter(t => t && (t.track.path !== uiTrack.track.path)))
        deselectTrack(uiTrack)

        // @ts-ignore
        if (uiTrack.progress || uiTrack.justUploaded)
            // @ts-ignore
            cancelUpload(uiTrack)
    }, [existingTracks])
    const [allTracks, setAllTracks] = useState<UITrack[]>([])
    useEffect(() => {
        setAllTracks([...fileUploadsArr, ...existingTracks])
    }, [existingTracks, fileUploadsArr])

    const allSelected = useMemo(() => selectedTracks?.length === allTracks?.length, [selectedTracks, allTracks])
    const someSelected = useMemo(() => selectedTracks?.length > 0, [selectedTracks])
    const toggleAll = useCallback(() => selectedTracks?.length ? setSelectedTracks([]) : setSelectedTracks([...allTracks]), [allTracks, selectedTracks])

    const deleteSelected = async () => Promise.all(selectedTracks.map(t => deleteTrack(t, false)))

    return { uploadFiles, allSelected, setTracks: setAllTracks, fileUploads, updateFileUpload, someSelected, deleteSelected, toggleAll, tracks: allTracks, loadMore: loadMoreExistingTracks, hasMore, selectTrack, deselectTrack, trackSelected, selectedTracks, fileUploadsArr, deleteTrack }
}